<template>
  <div class="root">
    <div class="banner">
      <img class="logo" :src="logo" />
      <span class="text">{{ projectName }}</span>
    </div>

    <div class="profile">
      <el-select
        style="margin-right: 20px; width: 200px"
        v-model="itemNameStyleValue"
        placeholder="请选择"
        @change="itemNameStyleChange"
      >
        <el-option
          v-for="item in itemNameStyleOptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-dropdown @command="onClickProfileDropdownMenuItem">
        <span class="username">
          {{ getLoginUsername()
          }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
          <el-dropdown-item command="setting">设置</el-dropdown-item>
          <el-dropdown-item command="logout">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

import store from "@/store";

export default {
  data() {
    return {
      projectName: "", // 项目名称
      logo: "", // logo的路径
      itemNameStyleValue: "DEFAULT",
      itemNameStyleOptions: [
        {
          label: "道具命名风格：默认",
          value: "DEFAULT",
        },
        {
          label: "道具命名风格：ID左置",
          value: "ID-LEFT",
        },
      ],
    };
  },

  async created() {
    // 取得项目名称
    this.projectName = store.projectInfo.name;

    this.itemNameStyleValue = await util.getFromLocalStorage("item-name-style");
    if (!this.itemNameStyleValue) {
      this.itemNameStyleValue = "DEFAULT";
    } else {
      this.itemNameStyleValue = this.itemNameStyleValue;
    }

    // 取得logo的路径
    if (
      store.projectInfo.logo.indexOf("http://") == 0 ||
      store.projectInfo.logo.indexOf("https://") == 0
    ) {
      this.logo = store.projectInfo.logo;
    } else {
      this.logo = util.getBackendApiBase() + store.projectInfo.logo;
    }

    // 将logo路径也作为网站的favicon
    util.setFavicon(this.logo);
  },
  components: {},

  methods: {
    async itemNameStyleChange(e) {
      await util.storeToLocalStorage("item-name-style", e, 0);

      location.reload();
    },
    /**
     *
     * @param {*} command
     */
    onClickProfileDropdownMenuItem(command) {
      switch (command) {
        case "logout": {
          this.onClickLogoutBtn();
          break;
        }
        case "setting": {
          this.onSettingBtn();
          break;
        }
        case "changePassword": {
          this.onClickChangePasswordBtn();
          break;
        }
      }
    },

    /**
     * 点击了“退出登录”按钮
     */
    onClickLogoutBtn() {
      util.removeFromLocalStorage("loginUser");
      util.gotoLoginPage();
    },

    /**
     * 点击了“修改密码”按钮
     */
    onClickChangePasswordBtn() {
      dialogutil.open("ChangePasswordDialog");
    },

    /**
     * 点击了“设置”按钮
     */
    onSettingBtn() {
      dialogutil.open("SettingDialog");
    },

    /**
     * 取得当前登录用户的用户名
     */
    getLoginUsername() {
      let loginUser = bizutil.getLoginUser();
      if (loginUser) {
        return loginUser.username;
      } else {
        return "";
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.root {
  z-index: 1001;
  height: 60px;
  width: 100%;
  position: fixed;
  background-color: #1a73e8;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.banner {
  position: relative;
  left: 8px;
  height: 70%;
  display: flex;
  align-items: center;
}

.banner .logo {
  height: 100%;
}

.banner .text {
  font-weight: bold;
  font-size: 1.4rem;
  color: white;
  margin-left: 8px;
}

.profile {
  position: relative;
  right: 10px;
  display: flex;
  justify-content: right;
  align-items: center;
  cursor: pointer;
}

.profile .username {
  color: white;
  font-size: 1.1rem;
}
</style>